'use client';
import {
  type MultiFieldInlineFormProps,
  MultiFieldInlineForm as SharedMultiFieldInlineForm,
} from '../../react/MultiFieldInlineForm';
import { GETAPP_MULTI_FIELD_BRAND_CONFIG as GA_BRAND_CONFIG_INTERNAL } from '../../react/brandConfig';

export type {
  FieldConfig,
  MultiFieldInlineFormProps,
} from '../../react/MultiFieldInlineForm';

// Export field presets and options for easy configuration
export {
  JOB_FUNCTION_OPTIONS,
  SENIORITY_OPTIONS,
  SINGLE_STEP_2_FIELDS,
  SINGLE_STEP_3_FIELDS,
  SINGLE_STEP_4_FIELDS,
  TWO_STEP_DEFAULT_FIELDS,
} from '../../react/MultiFieldInlineForm';

export const GETAPP_MULTI_FIELD_BRAND_CONFIG = GA_BRAND_CONFIG_INTERNAL;

const GetAppMultiFieldInlineForm = (props: MultiFieldInlineFormProps) => (
  <SharedMultiFieldInlineForm
    cardBackground="brand"
    {...props}
    brandConfig={GETAPP_MULTI_FIELD_BRAND_CONFIG}
  />
);

GetAppMultiFieldInlineForm.displayName = 'GetAppMultiFieldInlineForm';

export const MultiFieldInlineForm = GetAppMultiFieldInlineForm;
